import { apiErrorToToast, forceFileDownload } from "@/lib/utils";
import { exportQuizWithAnswers } from "@/requests/questionnaries/export-quiz-with-answers";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useExportQuizWithAnswersMutation = () => {
  return useMutation({
    mutationFn: exportQuizWithAnswers,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (response) => {
      let fileName = "";

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const match = contentDisposition?.match(/filename="(.+?)"/);
        fileName = match ? match[1] : null;
      }

      forceFileDownload(url, fileName || "report.xlsx");
    },
  });
};
